import React from 'react';
import { ProductCard } from './ProductCard';

export const ProductGrid = ({ products, onProductClick }) => {
  // Group products by category for section headers
  const automotive = products.filter(product => product.category === 'automotive');
  const residential = products.filter(product => product.category === 'residential');

  return (
    <div className="space-y-12">
      {/* Automotive Section */}
      {automotive.length > 0 && (
        <div id="automotive">
          <h3 className="text-2xl font-bold text-white mb-6 border-l-4 border-green-400 pl-4">
            Auto Plēves
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {automotive.map(product => (
              <ProductCard 
                key={product.id} 
                product={product} 
                onClick={() => onProductClick(product.id)}
              />
            ))}
          </div>
        </div>
      )}

      {/* Residential Section */}
      {residential.length > 0 && (
        <div id="residential">
          <h3 className="text-2xl font-bold text-white mb-6 border-l-4 border-green-400 pl-4">
            Mājokļu Plēves
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {residential.map(product => (
              <ProductCard 
                key={product.id} 
                product={product} 
                onClick={() => onProductClick(product.id)}
              />
            ))}
          </div>
        </div>
      )}

      {/* No Products Found */}
      {products.length === 0 && (
        <div className="text-center py-12">
          <p className="text-lg text-gray-300">No products found.</p>
        </div>
      )}
    </div>
  );
}; 